import ViewPadrao from "../views/ViewPadrao";
import EmpresaList from "../views/EmpresaList";
import EmpresaCad from "../views/EmpresaCad";

export default {
  path: "empresas",
  component: ViewPadrao,
  children: [
    {
      path: "",
      name: "empresas-list",
      component: EmpresaList,
      meta: {
        auth: true,
        perms: ["empresas.listar_empresas"]
      }
    },
    {
      path: "novo",
      name: "empresas-formulario",
      component: EmpresaCad,
      meta: {
        auth: true,
        perms: ["empresas.criar_empresas"]
      }
    },
    {
      path: "editar/:id",
      name: "empresas-formulario-editar",
      component: EmpresaCad,
      meta: {
        auth: true,
        perms: ["empresas.editar_empresas"]
      }
    }
  ]
};
